import React, {useState} from 'react';
import {Dialog} from 'primereact/dialog';
import {DataTable} from 'primereact/datatable';
import {Column} from 'primereact/column';
import {Button} from 'primereact/button';
import {Message} from 'primereact/message';
import {RadioButton} from 'primereact/radiobutton';
import {recruitmentApi} from '../recruitmentApi';

export const retainOtherPageSelection = (selected, page, next) => [
  ...selected.filter(item => !page.some(row => row.id === item.id)), ...next,
].filter((item, index, all) => all.findIndex(row => row.id === item.id) === index);

export default function CandidateMergeDialog({candidates, onHide, onMerged, t}) {
  const [primaryId, setPrimaryId] = useState(null);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const sorted = [...candidates].sort((a, b) => a.id - b.id);
  const merge = async () => {
    setBusy(true); setError('');
    try {
      await recruitmentApi('post', '/candidate/merge', {primary_id: primaryId, candidate_ids: sorted.map(row => row.id)});
      onMerged();
    } catch (e) {
      setError(e.response?.data?.detail || e.response?.data?.message || e.message);
    } finally { setBusy(false); }
  };
  return <Dialog visible header={t('candidateMerge.title')} onHide={() => !busy && onHide()}
    closable={!busy} style={{width: '850px', maxWidth: '95vw'}} modal
    footer={<><Button label={t('cancel')} className="p-button-text" disabled={busy} onClick={onHide}/>
      <Button label={t('candidateMerge.confirm')} icon="pi pi-check" disabled={!primaryId || busy} loading={busy} onClick={merge}/></>}>
    <Message severity="warn" text={t('candidateMerge.explanation')}/>
    {error && <div className="p-my-3"><Message severity="error" text={error}/></div>}
    <DataTable value={sorted} dataKey="id" responsiveLayout="scroll" className="p-mt-3">
      <Column header={t('candidateMerge.primary')} body={row => <RadioButton inputId={`primary-${row.id}`} name="primary-candidate"
        aria-label={`${t('candidateMerge.primary')}: ${row.name}`} value={row.id} checked={primaryId === row.id} disabled={busy} onChange={() => setPrimaryId(row.id)}/>}/>
      <Column field="name" header={t('columnName')}/>
      <Column field="email" header={t('fieldEmail')}/>
      <Column header={t('columnCreatedAt')} body={row => window.App.formatDateValue(row.created_at)}/>
    </DataTable>
  </Dialog>;
}
